import { createRoot } from 'react-dom/client'
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router";
import './css/index.css';
import Store from './Store/Store';
import App from './App/App';

/*
const root = document.getElementById("root");

Store.init( () => {
  root.render( <App /> )
})

createRoot(root).render( 
  <BrowserRouter>
    <App />
  </BrowserRouter>
)
*/

const container = document.getElementById('root');
const root = createRoot( container );

//Store.clear()

Store.init( () => {
  root.render( 
    <BrowserRouter>
      <App />
    </BrowserRouter>
  )
})
